import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../../utils/userProvider";
import { userLogout } from "../../../services/AuthService";
import { getStudentByEmail } from "../../../services/StudentService";
import { HSTSToast } from "../../../utils/hstsToast";

// const API_BASE_URL = "http://localhost:8285";
const API_BASE_URL = "https://hetras.suza.ac.tz/hetras";
const IMAGE_ENDPOINT_ROOT = "/students";
const DEFAULT_PROFILE_IMAGE = "/assets/img/c.png";

export const TopHeader = ({ sidebarOpen, setSidebarOpen, windowWidth }) => {
  const navigator = useNavigate();
  const { user, logout } = useUser();

  const [profileImageUrl, setProfileImageUrl] = useState(DEFAULT_PROFILE_IMAGE);

  useEffect(() => {
    if (user?.email) {
      getStudentByEmail(user.email)
        .then((response) => {
          const student = response.data;
          if (student.profileImage && student.studentId) {
            const timestamp = new Date().getTime();
            const baseImageUrl = `${API_BASE_URL}${IMAGE_ENDPOINT_ROOT}/${student.studentId}/profileImage`;
            setProfileImageUrl(`${baseImageUrl}?t=${timestamp}`);
          } else {
            setProfileImageUrl(DEFAULT_PROFILE_IMAGE);
          }
        })
        .catch((error) => {
          console.error("Error fetching student data for header:", error);
          setProfileImageUrl(DEFAULT_PROFILE_IMAGE);
        });
    }
  }, [user?.email]);

  const logoutHandler = async () => {
    try {
      await userLogout(); // Call backend logout to delete cookie
      logout(); // Clear context
      HSTSToast("success", "Logged out successfully");
      navigator("/");
    } catch (error) {
      console.error("Logout error:", error);
      HSTSToast("error", "Logout failed");
    }
  };

  return (
    <>
      <header className="bg-white border-bottom sticky-top">
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between py-3">
            <div className="d-flex align-items-center gap-3">
              <button
                className="btn btn-outline-secondary d-md-none"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                title="Toggle Sidebar"
              >
                <i className="fas fa-bars"></i>
              </button>
              <h6 className="mb-0 fw-bold d-md-none">
                HEET Students Tracking System (HETRAS)
              </h6>
            </div>

            <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
              <div className="container-fluid">
                <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
                  <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none"></li>

                  <li className="nav-item topbar-user dropdown hidden-caret">
                    <Link
                      className="dropdown-toggle profile-pic"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div className="avatar-sm">
                        <img
                          src={profileImageUrl}
                          alt={"studentProfile"}
                          className="avatar-img rounded-circle"
                        />
                      </div>
                      <span className="profile-username">
                        <span className="op-7 me-2">Welcome,</span>
                        <span className="fw-bold">{"Student"}</span>
                      </span>
                    </Link>
                    <ul className="dropdown-menu dropdown-user animated fadeIn">
                      <div className="dropdown-user-scroll scrollbar-outer">
                        <li>
                          <Link to="/student/profile" className="dropdown-item">
                            Profile Setting
                          </Link>
                          <div className="dropdown-divider"></div>
                        </li>
                        <li>
                          <Link
                            to="/student/password"
                            className="dropdown-item"
                          >
                            Account Setting
                          </Link>
                          <div className="dropdown-divider"></div>
                        </li>
                        <li>
                          <p
                            onClick={logoutHandler}
                            className="dropdown-item zis-ponter"
                          >
                            Logout
                          </p>
                        </li>
                      </div>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};
